import authService from '../services/auth-service';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.organicgreenshub.com';

const bottleReturnService = {
  // Submit bottle return request
  submitBottleReturn: async (bottleCount) => {
    try {
      const token = authService.getToken();
      const response = await fetch(`${API_URL}/api/bottle-returns/request`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ bottleCount: parseInt(bottleCount) })
      });

      if (!response.ok) throw new Error('Failed to submit request');
      return await response.json();
    } catch (error) {
      console.error('Error submitting bottle return:', error);
      throw error;
    }
  },

  // Get customer's bottle return requests
  getCustomerRequests: async (customerId) => {
    try {
      const token = authService.getToken();
      const response = await fetch(`${API_URL}/api/bottle-returns/requests/${customerId}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (!response.ok) throw new Error('Failed to fetch requests');
      return await response.json();
    } catch (error) {
      console.error('Error fetching bottle return requests:', error);
      throw error;
    }
  },

  // Get pending requests (admin only)
  getPendingRequests: async () => {
    try {
      const token = authService.getToken();
      const response = await fetch(`${API_URL}/api/bottle-returns/admin/pending`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (!response.ok) throw new Error('Failed to fetch pending requests');
      return await response.json();
    } catch (error) {
      console.error('Error fetching pending requests:', error);
      throw error;
    }
  },

  // Approve bottle return (admin only)
  approveBottleReturn: async (requestId, adminPassword) => {
    try {
      const token = authService.getToken();
      const response = await fetch(`${API_URL}/api/bottle-returns/admin/approve/${requestId}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ adminPassword })
      });

      if (!response.ok) throw new Error('Failed to approve request');
      return await response.json();
    } catch (error) {
      console.error('Error approving bottle return:', error);
      throw error;
    }
  },

  // Reject bottle return (admin only)
  rejectBottleReturn: async (requestId, reason) => {
    try {
      const token = authService.getToken();
      const response = await fetch(`${API_URL}/api/bottle-returns/admin/reject/${requestId}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ reason })
      });

      if (!response.ok) throw new Error('Failed to reject request');
      return await response.json();
    } catch (error) {
      console.error('Error rejecting bottle return:', error);
      throw error;
    }
  },

  // Get customer credits
  getCustomerCredits: async (customerId) => {
    try {
      const token = authService.getToken();
      const response = await fetch(`${API_URL}/api/bottle-returns/credits/${customerId}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (!response.ok) throw new Error('Failed to fetch credits');
      return await response.json();
    } catch (error) {
      console.error('Error fetching customer credits:', error);
      throw error;
    }
  },

  // Use credits for subscription
  useCredits: async (customerId, creditAmount, subscriptionId) => {
    try {
      const token = authService.getToken();
      const response = await fetch(`${API_URL}/api/bottle-returns/use/${customerId}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ creditAmount, subscriptionId })
      });

      if (!response.ok) throw new Error('Failed to use credits');
      return await response.json();
    } catch (error) {
      console.error('Error using credits:', error);
      throw error;
    }
  },

  // Update bottle credit value (admin only)
  updateCreditValue: async (creditPerBottle) => {
    try {
      const token = authService.getToken();
      const response = await fetch(`${API_URL}/api/bottle-returns/admin/settings`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ creditPerBottle: parseInt(creditPerBottle) })
      });

      if (!response.ok) throw new Error('Failed to update credit value');
      return await response.json();
    } catch (error) {
      console.error('Error updating credit value:', error);
      throw error;
    }
  },

  // Add manual credits (admin only)
  addManualCredits: async (customerMobile, creditAmount, adminPassword) => {
    try {
      const token = authService.getToken();
      const response = await fetch(`${API_URL}/api/bottle-returns/admin/add-credits`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ customerMobile, creditAmount: parseInt(creditAmount), adminPassword })
      });

      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        throw new Error('Server returned invalid response. Please check if the API endpoint is working.');
      }

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to add credits');
      }
      return await response.json();
    } catch (error) {
      console.error('Error adding manual credits:', error);
      throw error;
    }
  }
};

export default bottleReturnService;
